import React from 'react';
import { Modal, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';
import { surchargeTypes, appliedOn, surgeValueType } from '../utils';
import { Button } from '../../commons/utils';

const AddAndEditSurcharge = ({ isOpen, selectedSurcharge, save, cancel, dataChange, onValueBlur, t }) => {
    // when creating somethings options are undefined, I need to fill default value
    if (!selectedSurcharge.surchargeType) selectedSurcharge.surchargeType = 1;
    // if it is VAT surcharge, value type is %, because we disable the value type when vat, so we need to make sure selection is correct
    if (selectedSurcharge.surchargeType === 1) {
        selectedSurcharge.valueType = 1;
    }

    return (
        <Modal isOpen={isOpen} centered={true} size="lg">
            <ModalBody className="surcharges__form">
                <h5>{t('surcharge:taxData')}</h5>
                <hr />
                <div className="row">
                    <FormGroup className="col-md-8">
                        <Label for="name">
                            {t('name')}*<small> ({t('surcharge:maxChars')}</small>){' '}
                        </Label>
                        <Input id="name" type="text" onChange={e => dataChange('name', e.target.value)} value={selectedSurcharge.name} />
                    </FormGroup>
                </div>
                <div className="row">
                    <FormGroup className="col-md-4">
                        <Label for="surchargeType">{t('surcharge:taxType')}</Label>
                        <Input
                            id="surchargeType"
                            type="select"
                            onChange={e => {
                                dataChange('surchargeType', e.target.value);
                            }}
                            value={selectedSurcharge.surchargeType}
                        >
                            {surchargeTypes.map(surcharge => (
                                <option value={surcharge.type} key={`tax-${surcharge.name}`}>
                                    {t(`surcharge:${surcharge.name}`)}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                    <FormGroup className="col-md-4">
                        <Label for="appliedOn">{t('surcharge:appliedOn')}</Label>
                        <Input
                            type="select"
                            onChange={e => {
                                dataChange('appliedOn', e.target.value);
                            }}
                            value={selectedSurcharge.appliedOn}
                        >
                            {appliedOn.map(apply => (
                                <option value={apply.value} key={`tax-${apply.name}`}>
                                    {t(`surcharge:${apply.name}`)}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                </div>
                <div className="row">
                    <FormGroup className="col-md-8">
                        <Label for="value">{t('surcharge:taxValue')}*</Label>
                        <div className="surcharges__input">
                            <Input id="value" type="number" value={selectedSurcharge.value} onChange={e => dataChange('value', e.target.value)} onBlur={onValueBlur} />
                            <Input
                                type="select"
                                onChange={e => dataChange('valueType', e.target.value)}
                                value={selectedSurcharge.valueType}
                                disabled={selectedSurcharge.surchargeType === 1}
                            >
                                {surgeValueType.map(valueType => (
                                    <option value={valueType.type} key={`tax-${valueType.name}`}>
                                        {t(`surcharge:${valueType.name}`)}
                                    </option>
                                ))}
                            </Input>
                        </div>
                    </FormGroup>
                </div>

                <div className="row">
                    <FormGroup className="col-md-8">
                        <Label for="externalcode">{t('surcharge:externalCode')}</Label>
                        <div className="surcharges__input">
                            <Input
                                id="externalcode"
                                type="text"
                                value={selectedSurcharge.externalCode}
                                onChange={e => dataChange('externalCode', e.target.value)}
                            />
                        </div>
                    </FormGroup>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button type="cancel" onClick={cancel} text={t('cancel')}></Button>
                <Button
                    type="save"
                    text={t('save')}
                    disabled={!selectedSurcharge.name || selectedSurcharge.name?.length <= 2 || selectedSurcharge.value < 0}
                    onClick={save}
                />
            </ModalFooter>
        </Modal>
    );
};

export default AddAndEditSurcharge;
